export default __webpack_public_path__ + "static/3-152baf8cb295ded9ee9df628619bcbdf.jpeg";